<template>
  <div>
    <v-alert color="info" dense text> O valor cobrado por unidade. </v-alert>
    <v-text-field
      v-model="price"
      label="Valor por unidade"
      type="number"
      :min="0.01"
      :step="0.01"
      outlined
      dense
      prefix="R$"
      :rules="[
        (v) => !!v || 'Valor por unidade é obrigatório',
        (v) => parseFloat(v) > 0 || 'Valor por unidade deve ser maior que 0',
      ]"
      hide-details="auto"
    />
  </div>
</template>

<script>
export default {
  name: "Fixed",
  props: {
    value: {
      type: Object,
      default: () => ({
        value: 0,
      }),
    },
  },
  computed: {
    price: {
      get() {
        return this.value?.value ?? 0;
      },
      set(value) {
        this.$emit("input", {
          ...(this.value || {}),
          value: parseFloat(value),
        });
      },
    },
  },
  mounted() {
    this.price = this.price;
  },
};
</script>